(function () {
  var G = '#C9A227', B = '#0A0A0A', W = '#ffffff', D = '#dddddd', DIM = '#999';

  function sp(el, prop, val) {
    try { el.style.setProperty(prop, val, 'important'); } catch(e) {}
  }

  function cls(el) { return el.getAttribute('class') || ''; }

  function isTealBg(el) {
    var bg = window.getComputedStyle(el).backgroundColor;
    var m = bg.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (!m) return false;
    var r = +m[1], g = +m[2], b = +m[3];
    return g > 100 && g > r + 20 && (r + g + b) > 60;
  }

  // Returns true if element is inside the write review modal or form — skip these
  function inModal(el) {
    if (!el.closest) return false;
    return !!(
      el.closest('[class*="jdgm-write-review-modal"]') ||
      el.closest('.jdgm-form') ||
      el.closest('.jdgm-form-wrapper')
    );
  }

  function apply() {
    var all = document.querySelectorAll('[class*="jdgm"], [class*="jdgm"] *');

    // Force white text on widget elements — skip write review modal
    all.forEach(function (el) {
      if (inModal(el)) return;
      sp(el, 'color', W);
    });

    all.forEach(function (el) {
      if (inModal(el)) return;
      var c = cls(el);
      if (/\bjdgm-star\b/.test(c)) { sp(el, 'display', 'none'); return; }
      if (/\bjm-star-rating\b/.test(c)) { sp(el, 'display', 'none'); return; }
      if (/body|content|desc/i.test(c)) { sp(el, 'color', D); return; }
      if (/time|date/i.test(c)) { sp(el, 'color', DIM); return; }
      if (/pic|avatar|initials/i.test(c)) { sp(el, 'background-color', G); sp(el, 'color', B); return; }
      if (/fill/i.test(c)) { sp(el, 'background-color', G); return; }
    });

    // Hide star elements in widget — skip those inside write review modal/form
    document.querySelectorAll('.jdgm-star, .jdgm-rev__rating, .jm-star-rating').forEach(function (el) {
      if (inModal(el)) return;
      sp(el, 'display', 'none');
    });

    // Fix teal backgrounds on legacy pagination/filter elements
    all.forEach(function (el) {
      if (inModal(el)) return;
      if (!isTealBg(el)) return;
      var c = cls(el);
      if (/paginate|page/i.test(c)) { sp(el, 'background-color', G); sp(el, 'color', B); }
      else { sp(el, 'background-color', '#1a1a1a'); sp(el, 'border-color', G); }
    });

    // Revamp widget: override CSS variables inline so Vue can't reset them
    document.querySelectorAll('.jm-review-widget').forEach(function (el) {
      el.style.setProperty('--jm-widget-primary-color', G, 'important');
      el.style.setProperty('--jm-review-widget-button-color', G, 'important');
      el.style.setProperty('--jm-review-widget-star-and-histogram-color', G, 'important');
      el.style.setProperty('--jm-review-widget-button-text-color', B, 'important');
    });

    // Write button by text content — skip modal context
    document.querySelectorAll('[class*="jdgm"] a, [class*="jdgm"] button').forEach(function (el) {
      if (inModal(el)) return;
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt.indexOf('write') > -1) {
        sp(el, 'background-color', G); sp(el, 'background', G);
        sp(el, 'color', B); sp(el, 'border', 'none');
        sp(el, 'border-radius', '4px'); sp(el, 'font-weight', '700');
        el.querySelectorAll('*').forEach(function (ch) { sp(ch, 'color', B); });
      }
    });
  }

  function injectStyle() {
    var old = document.getElementById('bb-jdgm-s');
    if (old) old.remove();
    var s = document.createElement('style');
    s.id = 'bb-jdgm-s';
    s.textContent = [
      // Legacy jdgm CSS variables
      ':root{--jdgm-primary-color:' + G + ';--jdgm-star-color:' + G + ';--jdgm-paginate-color:' + G + ';--jdgm-reviewer-name-color:' + W + ';--jdgm-write-review-bg-color:' + G + ';--jdgm-write-review-text-color:' + B + ';--jdgm-clr-accent:' + G + ';--jdgm-clr-primary:' + G + '}',
      // Revamp jm widget CSS variables
      ':root{--jm-widget-primary-color:' + G + '!important;--jm-review-widget-button-color:' + G + '!important;--jm-review-widget-star-and-histogram-color:' + G + '!important;--jm-review-widget-button-text-color:' + B + '!important}',
      // Hide stars in the widget (not in modal)
      '.jdgm-star{display:none!important}',
      '.jdgm-rev__rating{display:none!important}',
      '.jm-star-rating{display:none!important}',
      '[class*="jm-star-rating"]{display:none!important}',
      // White text on widget elements
      'html body [class*="jdgm"]{color:' + W + '!important}',
      'html body [class*="jdgm"][class*="pic"],html body [class*="jdgm"][class*="avatar"]{background-color:' + G + '!important;color:' + B + '!important}',
      // Write review BUTTON (not modal)
      'html body .jdgm-write-rev-link,html body a.jdgm-write-rev-link{background:' + G + '!important;background-color:' + G + '!important;color:' + B + '!important;border:none!important;border-radius:4px!important;font-weight:700!important}',
      // NUCLEAR MODAL RESET — the outer modal class is "jdgm-write-review-modal" NOT "jdgm-modal"
      'html body [class*="jdgm-write-review-modal"]{color:#333!important;background:transparent!important}',
      'html body [class*="jdgm-write-review-modal"] *{color:#333!important;background:transparent!important}',
      'html body .jdgm-write-review-modal__container{background:#fff!important;color:#333!important}',
      'html body .jdgm-write-review-modal__overlay{background:rgba(0,0,0,0.6)!important}',
      // Stars VISIBLE and gold inside the write review modal
      'html body [class*="jdgm-write-review-modal"] .jdgm-star{display:inline-block!important;color:' + G + '!important;fill:' + G + '!important}',
      'html body [class*="jdgm-write-review-modal"] .jm-star-rating{display:inline-block!important;color:' + G + '!important}',
      // Title dark
      'html body .jdgm-write-review-modal__title{color:#111!important;font-size:1.4rem!important;font-weight:700!important}',
      // Form inputs inside modal
      'html body [class*="jdgm-write-review-modal"] input,html body [class*="jdgm-write-review-modal"] textarea,html body [class*="jdgm-write-review-modal"] select{background:#fff!important;color:#333!important;border:1px solid #ccc!important}',
      // Nav/submit buttons inside modal
      'html body [class*="jdgm-write-review-modal"] [class*="nav-btn"],html body [class*="jdgm-write-review-modal"] button[type="submit"]{background:' + G + '!important;color:' + B + '!important;border:none!important;border-radius:4px!important}',
      // Rest of widget colors
      'html body [class*="jdgm"][class*="fill"]{background-color:' + G + '!important}',
      'html body [class*="jdgm"][class*="body"]{color:' + D + '!important}',
      'html body [class*="jdgm"][class*="time"],html body [class*="jdgm"][class*="date"]{color:' + DIM + '!important}',
      'html body .jdgm-paginate__page:hover,html body .jdgm-paginate__page:focus{background-color:' + G + '!important;color:' + B + '!important;border-color:' + G + '!important;outline:2px solid ' + G + '!important;box-shadow:0 0 0 2px ' + G + '!important}',
      // Write review form
      'html body .jdgm-form,html body .jdgm-form-wrapper,html body .jdgm-write-rev-form{color:#333!important;background:#fff!important}',
      'html body .jdgm-form *,html body .jdgm-form-wrapper *{color:#333!important}',
      'html body .jdgm-form .jdgm-star,html body .jdgm-form-wrapper .jdgm-star{display:inline-block!important;color:' + G + '!important}',
      'html body .jdgm-form input,html body .jdgm-form textarea{background:#fff!important;color:#333!important;border:1px solid #ccc!important}',
      'html body .jdgm-form [class*="submit"],html body .jdgm-form button[type="submit"]{background:' + G + '!important;color:' + B + '!important}',
      // Hide review titles — name, date, body only
      '.jdgm-rev__title,[class*="jm-rev"][class*="title"],[class*="jm-review"][class*="title"]{display:none!important}',
    ].join('');
    (document.body || document.head).appendChild(s);
  }

  function attachDelegatedHover() {
    document.addEventListener('mouseover', function (e) {
      var el = e.target;
      for (var i = 0; i < 4 && el && el !== document; i++, el = el.parentElement) {
        if (/\bjdgm-paginate__page\b/.test(cls(el))) {
          sp(el, 'background-color', G); sp(el, 'color', B);
          sp(el, 'border-color', G); sp(el, 'box-shadow', '0 0 0 2px ' + G);
          sp(el, 'outline', 'none');
          break;
        }
      }
    });
    document.addEventListener('mouseout', function (e) {
      var el = e.target;
      for (var i = 0; i < 4 && el && el !== document; i++, el = el.parentElement) {
        if (/\bjdgm-paginate__page\b/.test(cls(el))) {
          el.style.removeProperty('background-color');
          el.style.removeProperty('color');
          el.style.removeProperty('border-color');
          el.style.removeProperty('box-shadow');
          break;
        }
      }
    });
  }

  apply();
  document.addEventListener('DOMContentLoaded', function () { injectStyle(); apply(); });
  window.addEventListener('load', function () {
    injectStyle(); apply();
    setTimeout(attachDelegatedHover, 2000);
    setTimeout(function () { injectStyle(); apply(); }, 1500);
    setTimeout(function () { injectStyle(); apply(); }, 4000);
  });
  var tries = 0;
  var iv = setInterval(function () {
    apply();
    if (++tries >= 60) clearInterval(iv);
  }, 500);
})();
